import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { DealerList, DealerListImportData } from '../models/models'

export class SaveDealerApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/orderReport/SetDailyOrderDealerList',
      requesterInfo,
    })
  }

  public async saveDealerApi(request: DealerListImportData): Promise<DealerList[]> {
    return await this.postAsync<DealerList[]>(request)
  }
}
